module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-style-wrap"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_vm._v("设置")]), _vm._v(" "), _c('div', {
    staticClass: "el-row"
  }, [_c('span', [_vm._v("网站版权：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.t_data.copyright),
      callback: function($$v) {
        _vm.$set(_vm.t_data, "copyright", $$v)
      },
      expression: "t_data.copyright"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-row"
  }, [_c('span', [_vm._v(" 许可编号： ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入许可号..."
    },
    model: {
      value: (_vm.t_data.license),
      callback: function($$v) {
        _vm.$set(_vm.t_data, "license", $$v)
      },
      expression: "t_data.license"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-row"
  }, [_c('span', [_vm._v("客服电话：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入客服电话..."
    },
    model: {
      value: (_vm.t_data.phone),
      callback: function($$v) {
        _vm.$set(_vm.t_data, "phone", $$v)
      },
      expression: "t_data.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-row"
  }, [_c('span', [_vm._v("服务时间：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入客服电话服务时间..."
    },
    model: {
      value: (_vm.t_data.time),
      callback: function($$v) {
        _vm.$set(_vm.t_data, "time", $$v)
      },
      expression: "t_data.time"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e0c2059", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e0c2059"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/footerPage/components/plugins/footer/style.vue
// module id = 2858
// module chunks = 0